var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1198 16.5593H9.14977C8.66978 16.5593 8.51978 16.3793 8.51978 15.9293V12.2993C8.51978 11.8193 8.69978 11.6693 9.14977 11.6693H12.1198V9.0293C12.1198 7.8293 12.3298 6.6893 12.9298 5.6393C13.5598 4.5593 14.4598 3.8393 15.5998 3.4193C16.3498 3.1493 17.0998 3.0293 17.9098 3.0293H20.8498C21.2698 3.0293 21.4498 3.2093 21.4498 3.6293V7.0493C21.4498 7.4693 21.2698 7.6493 20.8498 7.6493C20.0398 7.6493 19.2298 7.6493 18.4198 7.6793C17.6098 7.6793 17.1898 8.0693 17.1898 8.9093C17.1598 9.8093 17.1898 10.6793 17.1898 11.6093H20.6698C21.1498 11.6093 21.3298 11.7893 21.3298 12.2693V15.8993C21.3298 16.3793 21.1798 16.5293 20.6698 16.5293H17.1898V26.3093C17.1898 26.8193 17.0398 26.9993 16.4998 26.9993H12.7498C12.2998 26.9993 12.1198 26.8193 12.1198 26.3693V16.5593Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ab0c15c38f84abac1582ebe1e1c11767.svg";
export { ForwardRef as ReactComponent };